import { useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";
import BUSINESS_RULES from "../../content/businessRules.js";
import Hint from "./Hint.jsx";

// The "?" business-rules help. Drop next to a tab/section heading:
//
//   <h4>Orders <RulesHelp topic="orders" /></h4>
//
// Opens a side panel (Offcanvas) with the tab's rules in plain language, so users
// can see WHY the page behaves the way it does (disabled buttons, locked rows, …)
// instead of reporting rules as bugs. Content lives in src/content/businessRules.js;
// the developer version (with legacy sources) is docs/business-rules/*.md — update
// both when a rule changes.

function RulesHelp({ topic, placement = "end" }) {
  const [show, setShow] = useState(false);
  const content = BUSINESS_RULES[topic];
  if (!content) return null;

  return (
    <>
      <Hint label="How this tab works — the business rules">
        <Button
          variant="outline-secondary"
          size="sm"
          className="rounded-circle px-2 py-0 ms-1 align-middle"
          style={{ lineHeight: "1.4", fontSize: "0.8rem" }}
          onClick={(e) => {
            e.currentTarget.blur(); // focus keeps the tooltip alive under/after the panel
            setShow(true);
          }}
          aria-label={content.title}
        >
          ?
        </Button>
      </Hint>

      {/* restoreFocus off: refocusing the "?" on close would re-light its tooltip */}
      <Offcanvas show={show} onHide={() => setShow(false)} placement={placement} scroll backdrop restoreFocus={false}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{content.title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {content.intro ? <p className="text-muted small">{content.intro}</p> : null}
          {content.sections.map((s) => (
            <div key={s.heading} className="mb-3">
              <h6 className="border-bottom pb-1">{s.heading}</h6>
              <ul className="small mb-0 ps-3">
                {s.rules.map((r, i) => (
                  <li key={i} className="mb-1">{r}</li>
                ))}
              </ul>
            </div>
          ))}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default RulesHelp;
